import { render, staticRenderFns } from "./CoreSnackbar.vue?vue&type=template&id=1b23d42a&scoped=true"
import script from "./CoreSnackbar.vue?vue&type=script&lang=js"
export * from "./CoreSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CoreSnackbar.vue?vue&type=style&index=0&id=1b23d42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23d42a",
  null
  
)

export default component.exports